<template>
  <section class="section section-alt" id="floorplan">
    <div class="section-inner">
      <div
        class="section-header reveal"
        :class="{ visible: revealed.header }"
        ref="header"
      >
        <div class="section-number">04 / FLOOR PLAN</div>
        <h2 class="section-title">平面图</h2>
        <p class="section-desc">提前了解展馆布局，规划您的参观路线</p>
      </div>
      <div
        class="floorplan-container reveal"
        :class="{ visible: revealed.body }"
        ref="body"
      >
        <!-- <div class="floorplan-legend">
          <div class="legend-item">
            <div class="legend-color a"></div>
            A区 品牌养老机构
          </div>
          <div class="legend-item">
            <div class="legend-color b"></div>
            B区 老年用品/康复辅具
          </div>
          <div class="legend-item">
            <div class="legend-color c"></div>
            C区 智慧养老/信息技术
          </div>
          <div class="legend-item">
            <div class="legend-color d"></div>
            D区 医养结合/中医药
          </div>
          <div class="legend-item">
            <div class="legend-color e"></div>
            E区 金融保险/养老财富
          </div>
          <div class="legend-item">
            <div class="legend-color f"></div>
            F区 文化教育/旅居养老
          </div>
        </div> -->
        <div class="floorplan-image-wrap">
          <img
            src="/images/floor_plan.jpg"
            alt="第十届安徽省养老博览会展会平面图"
            class="floorplan-image"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FloorplanSection",
  data() {
    return {
      revealed: { header: false, body: false },
      observer: null,
    };
  },
  mounted() {
    if (typeof IntersectionObserver === "undefined") {
      this.revealed.header = true;
      this.revealed.body = true;
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === this.$refs.header) this.revealed.header = true;
            if (entry.target === this.$refs.body) this.revealed.body = true;
          }
        });
      },
      { threshold: 0.12 }
    );
    if (this.$refs.header) this.observer.observe(this.$refs.header);
    if (this.$refs.body) this.observer.observe(this.$refs.body);
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style scoped>
/* ====== Section common ====== */
.section {
  padding: 120px 32px;
  position: relative;
}

.section-alt {
  background: var(--color-bg-warm);
}

.section-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 72px;
}

.section-number {
  display: inline-block;
  font-family: var(--font-serif);
  font-size: 14px;
  color: var(--color-primary);
  font-weight: 700;
  letter-spacing: 3px;
  margin-bottom: 16px;
  position: relative;
  padding: 0 40px;
}

.section-number::before,
.section-number::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 30px;
  height: 1px;
  background: var(--color-primary-light);
}

.section-number::before {
  left: 0;
}
.section-number::after {
  right: 0;
}

.section-title {
  font-family: var(--font-serif);
  font-weight: 900;
  font-size: clamp(32px, 4vw, 48px);
  color: var(--color-text);
  margin-bottom: 16px;
  line-height: 1.2;
}

.section-desc {
  font-size: 16px;
  color: var(--color-text-light);
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.8;
}

.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.reveal.visible {
  opacity: 1;
  transform: translateY(0);
}

/* ====== 展会平面图 Section ====== */
.floorplan-container {
  background: var(--color-white);
  border-radius: var(--radius-lg);
  padding: 48px;
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-md);
}

.floorplan-legend {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 40px;
  padding-bottom: 24px;
  border-bottom: 1px dashed var(--color-border);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--color-text-light);
  font-weight: 500;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.legend-color.a {
  background: #e8c4b4;
}
.legend-color.b {
  background: #e8d7a8;
}
.legend-color.c {
  background: #c5d5b8;
}
.legend-color.d {
  background: #b8cfe0;
}
.legend-color.e {
  background: #d5b8d0;
}
.legend-color.f {
  background: #f0d4a8;
}

.floorplan-image-wrap {
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
}

.floorplan-image {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.4s ease;
}

.floorplan-image-wrap:hover .floorplan-image {
  transform: scale(1.02);
}

@media (max-width: 968px) {
  .section {
    padding: 80px 24px;
  }
}

@media (max-width: 640px) {
  .floorplan-container {
    padding: 24px 16px;
  }
}
</style>
